const productStories = document.querySelectorAll('.product .product-stories .item');

const FSproductStories = document.querySelector('.full-screen-product-stories');
const FSproductStoriesItems = FSproductStories.querySelectorAll('.item');
const FSproductStoriesVideo = FSproductStories.querySelectorAll('video');
const FSproductStoriesControls = FSproductStories.querySelectorAll('.controls');

let IdLastVideoOpen;

function resetFSproductStories(){
    for(let i=0;i<FSproductStoriesVideo.length;i++){

        // STOPED VIDEOS
        FSproductStoriesVideo[i].pause();

        /* CHANGE PLAYBACK ICONS
        const controlsBtns = FSproductStoriesControls[i].querySelectorAll('.btn');
        for(let y=0;y<controlsBtns.length;y++){
            if(controlsBtns[y].classList.contains('playback')){
                controlsBtns[y].classList.remove('break');
                controlsBtns[y].classList.add('play');
            }
        }
        */

        // RESET VIDEO
        FSproductStoriesVideo[i].currentTime = 0;
    }
}

function closeFSproductStories(){
    FSproductStories.classList.remove('open');
    resetFSproductStories();
}
function openFSproductStories(){
    FSproductStories.classList.add('open');
}

productStories.forEach(story => {

    // START VIDEO LOOP

    const storyVideo = story.querySelector('video');

    storyVideo.play();

    storyVideo.addEventListener('timeupdate', function() {
        if (storyVideo.currentTime > 5) {
            storyVideo.currentTime = 0;
            storyVideo.play();
        }
    });

    // CLICK EVENT

    story.addEventListener('click', () => {
        if(story.classList.contains('open')){
            closeFSproductStories();
        }else{
            openFSproductStories();
        }

        for(let i=0;i<productStories.length;i++){
            if(parseInt(FSproductStoriesItems[i].dataset.id) == parseInt(story.dataset.id)){
                FSproductStoriesItems[i].classList.add('active');
                const video = FSproductStoriesItems[i].querySelector('video');
                console.log(video);
                video.play();
            }else{
                FSproductStoriesItems[i].classList.remove('active');
            }
            IdLastVideoOpen = parseInt(story.dataset.id);
        }
    })

});

/* CONTROLS */

FSproductStoriesItems.forEach(video => {

    const FSproductStoriesControlsBtn = video.querySelectorAll('.controls .btn');

    FSproductStoriesControlsBtn.forEach(btn => {
        btn.addEventListener('click', () => {
            
            if(btn.classList.contains('sound')){
                // SOUND
                if(btn.classList.contains('off')){
                    btn.classList.remove('off');
                }else{
                    btn.classList.add('off');
                }
                FSproductStoriesVideo[IdLastVideoOpen].muted = !FSproductStoriesVideo[IdLastVideoOpen].muted;
                
            }else if(btn.classList.contains('playback')){
                // PLAYBACK
                if(btn.classList.contains('play')){
                    btn.classList.remove('play');
                    btn.classList.add('break');
                    FSproductStoriesVideo[IdLastVideoOpen].play();
                }else if(btn.classList.contains('break')){
                    btn.classList.remove('break');
                    btn.classList.add('play');
                    FSproductStoriesVideo[IdLastVideoOpen].pause();
                }
            }else if(btn.classList.contains('close')){
                // CLOSE
                closeFSproductStories();
            }

        })
    })

})

/* PROGRESS BAR */

const FSprogressBarProgress = document.querySelectorAll('.full-screen-product-stories .progress-bar .progress');
console.log(FSprogressBarProgress);

FSprogressBarProgress.forEach(video => {
    video.addEventListener('timeupdate', () =>{
        const pourcentage = (video.currentTime / video.duration) * 100;
        video.style.width = `${pourcentage}%`;
    });
})